import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { colors } from "@/theme";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { GoogleButton } from "@/components/GoogleAuth";
import { toast } from "sonner";

export default function Signup() {
  const [form, setForm] = useState({ name: "", email: "", mobile: "", password: "" });
  const [busy, setBusy] = useState(false);
  const { signup } = useAuth();
  const navigate = useNavigate();

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await signup({ ...form, name: form.name.trim(), email: form.email.trim(), mobile: form.mobile.trim() });
      toast.success(`Welcome to the Nest, ${u.name.split(" ")[0]}`);
      navigate("/", { replace: true });
    } catch (err) {
      toast.error(err.message || "Signup failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ minHeight: "80vh", display: "flex", alignItems: "center", padding: "48px 24px" }}>
      <div className="form-narrow fade-up">
        <div style={{ textAlign: "center", marginBottom: 32 }}><Logo size={30} /></div>
        <h1 className="font-display" style={{ fontSize: 34, fontWeight: 700, margin: 0, textAlign: "center" }}>Create account</h1>
        <p className="font-body" style={{ textAlign: "center", color: colors.mutedText, marginTop: 8, marginBottom: 28 }}>Join Garlic by Urban Nest</p>
        <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div>
            <label className="eyebrow" style={{ display: "block", marginBottom: 8 }}>Full Name</label>
            <input data-testid="signup-name" className="input-field" value={form.name} onChange={set("name")} placeholder="Aditi Sharma" required />
          </div>
          <div>
            <label className="eyebrow" style={{ display: "block", marginBottom: 8 }}>Email</label>
            <input data-testid="signup-email" className="input-field" type="email" value={form.email} onChange={set("email")} placeholder="you@example.com" required />
          </div>
          <div>
            <label className="eyebrow" style={{ display: "block", marginBottom: 8 }}>Mobile</label>
            <input data-testid="signup-mobile" className="input-field" value={form.mobile} onChange={set("mobile")} placeholder="9876543210" required />
          </div>
          <div>
            <label className="eyebrow" style={{ display: "block", marginBottom: 8 }}>Password</label>
            <input data-testid="signup-password" className="input-field" type="password" value={form.password} onChange={set("password")} placeholder="Choose a password" required minLength={6} />
          </div>
          <button data-testid="signup-submit" className="btn-primary" type="submit" disabled={busy} style={{ marginTop: 8 }}>
            {busy ? "Creating…" : "Create Account"}
          </button>
        </form>
        <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "22px 0" }}>
          <div style={{ flex: 1, height: 1, background: colors.border }} />
          <span className="eyebrow">or</span>
          <div style={{ flex: 1, height: 1, background: colors.border }} />
        </div>
        <GoogleButton label="Sign up with Google" />
        <p className="font-body" style={{ textAlign: "center", marginTop: 24, fontSize: 14, color: colors.mutedText }}>
          Already have an account? <Link data-testid="go-login" to="/login" style={{ color: colors.brand, fontWeight: 600 }}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}
